import { Field } from '../api';

export function titleFor(key: string, fields: Field[]) {
  const f = fields.find(x => x.name === key);
  if (f) return f.title;
  const k = (key || '').toLowerCase();
  if (k === 'description') return 'Description';
  if (k === 'subfolder') return 'Subfolder';
  if (k === 'documentid' || k === 'docid' || k === 'id') return 'Document Id';
  if (k === 'createdate') return 'Create Date';
  return key;
}
